import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyATQ0Qn8iqlhX0hLdsH4vP9D4qqTbIgOz4",
  authDomain: "spanish-ova-funifelt.firebaseapp.com",
  projectId: "spanish-ova-funifelt",
  storageBucket: "spanish-ova-funifelt.appspot.com",
  messagingSenderId: "814150207994",
  appId: "1:814150207994:web:22de46e9f953edcd5b3c43",
  measurementId: "G-6WB7Y7T5XS"
}

// Initialize Firebase
initializeApp(firebaseConfig)
const db = getFirestore()

// Create Vue app
const app = createApp(App)
app.use(router)
app.mount('#app')

export {
  db
}